<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="550"
      content-class="rounded-dialog"
    >
      <v-card color="white">
        <v-form ref="PendingRemarksFormref" @submit.prevent>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">Add Pending Remarks</div>

                  <div class="dialog-subtitle">
                    Provide the remarks for this pending request.
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="close()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text style="max-height: 150px" class="my-4">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Type your remarks here ..."
                  v-model="remarksMsg"
                  outlined
                  dense
                  :rules="[formRules.required]"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn class="btn-cancel" outlined @click="close()"> Cancel </v-btn>

            <v-btn
              class="btn-save"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
              @click="handleSave()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  props: {
    data: null,
    action: null,
    moduleFrom: null,
    type: null,
  },
  components: { icon },
  data() {
    return {
      dialog: false,
      remarksMsg: null,
      isSubmitLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        if (data) {
          this.remarksMsg = null;
          this.dialog = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("closeRemarks", null);
    },
    handleSave() {
      this.isSubmitLoading = true;
      if (this.$refs.PendingRemarksFormref.validate()) {
        let data = {
          module_from: this.moduleFrom,
          id_to_remark: this.data.id,
          type_of: this.type,
          message: this.remarksMsg,
        };

        this.axiosCall("/remarks/set-pending-remarks", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.isSubmitLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.$emit("saveRemarks", res.data.data);
              this.dialog = false;
              // this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      }
    },
  },
};
</script>
